enum Routes {
  DASHBOARD = '/dashboard',
}

export default Routes;
